import React from 'react'
import { Grid } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import Labels from './../../../../common/Labels';
import EditText from '../../../../common/EditText';
import SingleLineEditText from '../../../../common/SingleLineEditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';
import { singleLineText } from '../../../../common/RegexValidation'
import { source } from 'react-aim';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Details Card');
    }
})

class Details extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            description: props.selectedPracticeLibrary.description,
            prerequisite: props.selectedPracticeLibrary.prerequisite,
        }
    }

    saveData = (data) => {

        if (data.name === 'Name') {
            this.props.selectedPracticeLibrary.oldName = this.props.selectedPracticeLibrary.name
            data.text = data.text.replace(/\s+/g,' ').trim();
            this.props.selectedPracticeLibrary.name = data.text.trim();
            this.props.selectedPracticeLibrary.slug = data.text.toLowerCase();
            if ((singleLineText.test(data.text))) {
                //dispatch.lifeCycle.updatePacksList({ _id: this.props.selectedPracticeLibrary._id, data: { name: data.text } });
                dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
            }
        } else if (data.name === 'Description') {
            this.props.selectedPracticeLibrary.description = data.text;
            dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
        } else if (data.name === 'Prerequisite') {
            this.props.selectedPracticeLibrary.prerequisite = data.text;
            dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
        }
    }

    render() {
        let customeError = this.props.playbookError ?
            <div style={{ marginTop: '-10px' }}>
                <span style={{ color: "red", fontSize: '0.8rem', margin: '0 0 0em' }}>
                    {this.props.playbookError + 'Please rename the playbook.'}
                </span> <br />
            </div>
            : ''

        return (
            <div >
                <Form noValidate
                    className="formcyForm"
                    ref={ref => this.form = ref}
                    onValidSubmit={this.props.onSubmit}
                >
                    <Grid>
                        <Grid.Row className="">
                            <Grid.Column width={16}>
                                {this.props.selectedPracticeLibrary.status !== 0 ?
                                    <Labels
                                        name="Name"
                                        text={this.props.selectedPracticeLibrary.name}
                                        editable={true} />
                                    :
                                    <SingleLineEditText
                                        name="Name"
                                        text={this.props.selectedPracticeLibrary.name}
                                        type="text"
                                        onSaveClick={this.saveData}
                                        isError={this.props.playbookError ? true : false}
                                    />
                                }
                            </Grid.Column>
                            {customeError}

                            <Grid.Column width={16}>
                                {this.props.selectedPracticeLibrary.status !== 0 ?
                                    <Labels
                                        name="Description"
                                        text={this.props.selectedPracticeLibrary.description}
                                        htmlView={true} />
                                    :
                                    <MultiLineEditText
                                        name="Description"
                                        text={this.props.selectedPracticeLibrary.description}
                                        type="textarea"
                                        htmlView={true}
                                        onSaveClick={this.saveData}
                                    />
                                }
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.props.selectedPracticeLibrary.status !== 0 ?
                                    <Labels
                                        name="Prerequisite"
                                        text={this.props.selectedPracticeLibrary.prerequisite}
                                        htmlView={true} />
                                    :
                                    <MultiLineEditText
                                        name="Prerequisite"
                                        text={this.props.selectedPracticeLibrary.prerequisite}
                                        type="textarea"
                                        htmlView={true}
                                        onSaveClick={this.saveData}
                                    />
                                }
                            </Grid.Column>
                            {this.props.selectedPracticeLibrary.baseId && 
                            <Grid.Column width={16}>
                                <Labels
                                    name="Base Id"
                                    text= {this.props.selectedPracticeLibrary.baseId}
                                 />
                            </Grid.Column>}
                        </Grid.Row>
                    </Grid>
                </Form>
            </div >
        )
    }
}

export default Details